// oxlint-disable-next-line import/no-default-export
export default [
  'INIT',
  'REALTIME_DATA_UPDATE',
  'TOGGLE_SECONDARY_PANEL',
  'REFETCH_LIVE_DATA',
  'POLL_ANSWERED',
  'ON_SPEAKERS_INIT',
]
